import * as Yup from 'yup';

export default Yup.object().shape({
  event: Yup.object().shape({
    type: Yup.string().required(
      'Let us know what type of event you’re planning.'
    ),
  }),
});
